export default "__VITE_ASSET__DSeQbLiG__"